// Design Tokens - Borders
// Use these tokens for all border-related values
// Based on FarLabs modern design system

export const borders = {
  // Border radius - More rounded for modern aesthetic
  radius: {
    none: '0',
    xs: '4px',
    sm: '6px',
    md: '10px',
    lg: '14px',
    xl: '18px',
    '2xl': '24px',
    '3xl': '32px',
    full: '9999px',
  },

  // Border widths
  width: {
    none: '0',
    thin: '1px',
    medium: '2px',
    thick: '3px',
    heavy: '4px',
  },

  // Component-specific borders - Matches FarLabs website
  component: {
    default: {
      radius: '12px',
      width: '1px',
    },
    card: {
      radius: '20px',       // Generous rounding for cards (matches website stats cards)
      width: '1px',
    },
    button: {
      radius: '14px',       // Very rounded buttons (matches Connect GPU, GitHub buttons)
      width: '1px',
    },
    buttonLarge: {
      radius: '16px',       // Even more rounded for large buttons
      width: '1px',
    },
    input: {
      radius: '12px',
      width: '1px',
    },
    modal: {
      radius: '24px',
      width: '1px',
    },
    badge: {
      radius: '999px',      // Full pill shape (matches REVENUE SUPERSTRUCTURE badge)
      width: '1px',
    },
    nav: {
      radius: '16px',       // Navigation bar rounding
      width: '1px',
    },
  },
} as const;
